import { Pipe, PipeTransform } from '@angular/core';
import Permission from '../interfaces/permission';

export const checkPermission = (
  permission: Permission | null,
  permissionKey: PermissionKey,
  field?: string
) => {
  if (!permission) {
    return false;
  }
  if (permissionKey === '_edit') {
    if (permission.authorized_fields && field) {
      return permission.authorized_fields.split(',').indexOf(field) > -1;
    }
  }
  return !!permission[permissionKey];
};
type PermissionKey = keyof Permission;
@Pipe({
    name: 'permission',
    standalone: false
})
export class PermissionPipe implements PipeTransform {
  public transform(
    permission: Permission | null,
    permissionKey: PermissionKey,
    field?: string
  ): boolean {
    return checkPermission(permission, permissionKey, field);
  }
}
